import {bp} from '../core/namespace.js';

$.extend(true, bp, {
  advertisement: (function () {
    var partnerCarouselStartIndex = null;

    function appendBrokerSelection(url, brokerId) {
      if (!url || !brokerId) {
        return url;
      }
      var separator = url.indexOf('?') === -1 ? '?' : '&';
      return url + separator + 'broker_user_id=' + encodeURIComponent(brokerId);
    }

    function getSelectedBrokerId() {
      var selectedBrokerId = '';
      $('.js-broker-selector').each(function () {
        if ($(this).val()) {
          selectedBrokerId = $(this).val();
          return false;
        }
      });
      if (!selectedBrokerId) {
        var hiddenBrokerField = $('input[name="broker_user_id"]');
        if (hiddenBrokerField.length && hiddenBrokerField.val()) {
          selectedBrokerId = hiddenBrokerField.val();
        }
      }
      return selectedBrokerId;
    }

    return {
      contact_details_url_for_selected_broker: function (url) {
        return appendBrokerSelection(url, getSelectedBrokerId());
      },
      partner_carousel_start_index: function (itemCount) {
        if (partnerCarouselStartIndex === null) {
          partnerCarouselStartIndex = Math.floor(Math.random() * itemCount);
        }
        return partnerCarouselStartIndex % itemCount;
      },
      init_inquiry_form: function () {
        var brokerSelectionModal = $('#broker-selection-modal');
        var pendingBrokerAction = null;

        function syncPartnerCarousel(brokerId) {
          if (window.bpPartnerAdvertiserCarousel && brokerId) {
            window.bpPartnerAdvertiserCarousel.showByBrokerId(brokerId);
          }
        }

        function syncSelectedBroker(brokerId) {
          $('.js-broker-selector').each(function () {
            $(this).val(brokerId);
          });
          $('.js-select-broker-option').removeClass('active');
          $('.js-select-broker-option[data-broker-id="' + brokerId + '"]').addClass('active');
          syncPartnerCarousel(brokerId);
        }

        function hasMultipleBrokerRequirement() {
          return $('.js-broker-selector').length > 0;
        }

        function ensureBrokerSelection(nextAction) {
          if (!hasMultipleBrokerRequirement()) {
            return true;
          }

          if (getSelectedBrokerId()) {
            return true;
          }

          if (!brokerSelectionModal.length) {
            return true;
          }

          pendingBrokerAction = nextAction;
          brokerSelectionModal.modal('show');
          return false;
        }

        function hideInquiryChrome() {
          $('.contact-card').find('.contact-header, .btn-show-contact-details').hide();
        }

        function followupWidgets() {
          return $('.js-inquiry-followup');
        }

        function remainingFollowupCards($root) {
          return $root.find('.js-inquiry-followup-card').not('.is-contacted');
        }

        function setFollowupState($root, state) {
          var showForm = state === 'form';
          $root.find('.js-followup-thanks').toggle(!showForm);
          $root.find('.js-followup-form-panel').prop('hidden', !showForm);
          $root.find('.js-followup-listings-panel').toggle(!showForm && remainingFollowupCards($root).length > 0);
        }

        function showFollowupSent($root, address) {
          $root.find('.js-followup-eyebrow').text('Ook verstuurd');
          $root.find('.js-followup-copy').text('De makelaar van ' + address + ' heeft uw bericht ontvangen.');
          $root.find('.js-followup-listings-heading').text('Nog een pand?');
          $root.find('.js-followup-more-link').hide();
          setFollowupState($root, 'list');
        }

        function showFollowupForm($root, $card) {
          var address = $.trim(String($card.data('address') || ''));
          var meta = $.trim(String($card.data('meta') || ''));
          var inquiryUrl = $card.data('inquiryUrl');
          var listingId = $card.data('listingId');
          if (!inquiryUrl || !listingId) {
            return;
          }
          $root.find('.js-followup-form-address').text(address).attr('href', $card.data('listingUrl') || '#');
          $root.find('.js-followup-form-meta').text(meta);
          $root.find('.js-followup-advertisement-id').val(listingId);
          $root.find('.js-followup-broker-user-id').val($card.data('brokerUserId'));
          $root.find('.js-inquiry-followup-form').attr('action', inquiryUrl);
          $root.find('.js-followup-error').prop('hidden', true).text('');
          setFollowupState($root, 'form');
        }

        function markFollowupListingContacted(listingId) {
          followupWidgets().find('.js-inquiry-followup-card').filter(function () {
            return String($(this).data('listingId')) === String(listingId);
          }).addClass('is-contacted');
        }

        var FOLLOWUP_SEND_FAILED = 'Het bericht kon niet worden verstuurd. Probeer het opnieuw.';

        function followupErrorMessage(errors) {
          var messages = [].concat.apply([], Object.values(errors || {}));
          return messages[0] || FOLLOWUP_SEND_FAILED;
        }

        function submitFollowupForm(inquiry_form) {
          var $root = inquiry_form.closest('.js-inquiry-followup');
          var $submit = inquiry_form.find('.js-followup-submit');
          var listingId = inquiry_form.find('.js-followup-advertisement-id').val();
          var address = $.trim($root.find('.js-followup-form-address').text());
          $submit.prop('disabled', true);
          $root.find('.js-followup-error').prop('hidden', true).text('');

          $.post(inquiry_form.attr('action'), inquiry_form.serialize()).done(function (data) {
            $submit.prop('disabled', false);
            if (data.result === 'ok') {
              markFollowupListingContacted(listingId);
              followupWidgets().each(function () {
                showFollowupSent($(this), address);
              });
              if (typeof ga === 'function') {
                ga('send', {
                  'hitType': 'event',
                  'eventCategory': 'estate_offer',
                  'eventAction': 'inquiry_form_sent',
                  'eventLabel': listingId
                });
              }
            } else {
              $root.find('.js-followup-error').text(followupErrorMessage(data.errors)).prop('hidden', false);
            }
          }).fail(function () {
            $submit.prop('disabled', false);
            $root.find('.js-followup-error').text(FOLLOWUP_SEND_FAILED).prop('hidden', false);
          });
        }

        function handleInquirySubmit(inquiry_form) {
          var inquiry_form_outer = inquiry_form.closest('.inquiry-form-outer');
          var contactAnchor = $('#contact_form_anchor');

          if (contactAnchor.length) {
            $('html,body').animate({scrollTop: contactAnchor.offset().top - 60}, 'slow');
          }

          inquiry_form_outer.html('<div style="width: 100%; text-align: center;"><img src="' + static_url + 'img/loading-spinner-squares-128px.gif" height="128" width="128" /></div>');

          $.post(inquiry_form.attr('action'), inquiry_form.serialize()).done(
            function (data) {
              if (data.result === 'ok') {
                if (data.html) {
                  $('.inquiry-form-outer').html(data.html);
                  hideInquiryChrome();
                } else {
                  inquiry_form_outer.html('<div class="sidebar-widget-inner">Uw bericht is verzonden naar de aanbieder.</div>');
                }
                if (typeof ga === 'function') {
                  ga('send', {
                    'hitType': 'event',
                    'eventCategory': 'estate_offer',
                    'eventAction': 'inquiry_form_sent',
                    'eventLabel': advertisement_data.pk,
                  });
                }
              } else {
                inquiry_form_outer.replaceWith(data.form_html);
                bp.advertisement.recaptcha_onload_callback();
              }
            }
          );
        }

        $(document).on('change', '.js-broker-selector', function () {
          syncSelectedBroker($(this).val());
        });

        document.addEventListener('bpBrokerCarouselChanged', function (event) {
          if (!event.detail || !event.detail.brokerId) {
            return;
          }
          var brokerId = String(event.detail.brokerId);
          $('.js-broker-selector').each(function () {
            $(this).val(brokerId);
          });
          $('.js-select-broker-option').removeClass('active');
          $('.js-select-broker-option[data-broker-id="' + brokerId + '"]').addClass('active');
        });

        $(document).on('click', '.js-select-broker-option', function () {
          var brokerId = String($(this).data('brokerId'));
          syncSelectedBroker(brokerId);
          brokerSelectionModal.modal('hide');
          if (typeof pendingBrokerAction === 'function') {
            var callback = pendingBrokerAction;
            pendingBrokerAction = null;
            callback();
          }
        });

        $(document).on('submit', '.js-inquiry-followup-form', function (event) {
          event.preventDefault();
          submitFollowupForm($(this));
        });

        $(document).on('submit', '.inquiry-form:not(.js-inquiry-followup-form), .inquiry-form-search', function (event) {
          event.preventDefault();
          var inquiry_form = $(this);
          if (!ensureBrokerSelection(function () {
            inquiry_form.trigger('submit');
          })) {
            return;
          }
          handleInquirySubmit(inquiry_form);
        });

        $(document).on('click', '.js-inquiry-followup-open', function (event) {
          event.preventDefault();
          var listingId = $(this).closest('.js-inquiry-followup-card').data('listingId');
          followupWidgets().each(function () {
            var $root = $(this);
            var $card = $root.find('.js-inquiry-followup-card').filter(function () {
              return String($(this).data('listingId')) === String(listingId);
            }).first();
            if ($card.length) {
              showFollowupForm($root, $card);
            }
          });
        });

        $(document).on('click', '.js-inquiry-followup-back', function (event) {
          event.preventDefault();
          followupWidgets().each(function () {
            setFollowupState($(this), 'list');
          });
        });

        $(document).on('click', '.btn-show-contact-details', function (event) {
          event.preventDefault();
          var btn_show_contact_details = $(this);
          if (!ensureBrokerSelection(function () {
            btn_show_contact_details.trigger('click');
          })) {
            return;
          }

          var selectedBrokerId = getSelectedBrokerId();
          var contact_details_url = appendBrokerSelection(
            btn_show_contact_details.attr('href'),
            selectedBrokerId
          );
          var spinner_html = $('<div style="width: 100%; text-align: center;"><img src="' + static_url + 'img/loading-spinner-squares-128px.gif" height="128" width="128" /></div>');
          btn_show_contact_details.replaceWith(spinner_html);
          $.get(contact_details_url).done(function (data) {
            spinner_html.replaceWith(data.html);
            if (typeof ga === 'function') {
              ga('send', {
                'hitType': 'event',
                'eventCategory': 'estate_offer',
                'eventAction': 'contact_link_click',
                'eventLabel': advertisement_data.pk,
              });
            }
          });
        });

        $(document).on('click', '.js-mobile-contact-trigger', function (event) {
          event.preventDefault();
          var mobileTrigger = $(this);
          if (!ensureBrokerSelection(function () {
            mobileTrigger.trigger('click');
          })) {
            return;
          }

          var selectedBrokerId = getSelectedBrokerId();
          var phoneMap = window.bpAdvertisementBrokerPhoneMap || {};
          var selectedPhone = phoneMap[selectedBrokerId] || '';
          var detailsUrl = appendBrokerSelection(
            window.bpAdvertisementContactDetailsUrl || '',
            selectedBrokerId
          );

          if (detailsUrl) {
            $.get(detailsUrl);
          }

          if (selectedPhone) {
            window.location.href = 'tel:' + selectedPhone;
          }
        });
      },
      recaptcha_onload_callback: function () {
        $('form.inquiry-form.has-errors').each(function () {
          bp.advertisement.render_recaptcha($(this));
        });

        $(document).on('focus', 'form.inquiry-form', function () {
          bp.advertisement.render_recaptcha($(this));
        });

        $(document).on('focus', 'form.inquiry-form-search', function () {
          bp.advertisement.render_recaptcha($(this));
        });
      },
      render_recaptcha: function (inquiryForm) {
        if (inquiryForm.children('.recaptcha-explicit').length) {
          var recaptchaField = inquiryForm.find('.recaptcha-explicit').first();
          if (recaptchaField.html() === '') {
            grecaptcha.render(recaptchaField[0], {sitekey: recaptchaField.data('recaptcha-sitekey')});
          }
        }
      },
      render_recaptcha_ratelimit_form: function () {
        var ratelimitForm = $('#bp_rate_limit_form');
        if (ratelimitForm.children('.recaptcha-explicit').length) {
          var recaptchaField = ratelimitForm.find('.recaptcha-explicit').first();
          if (recaptchaField.html() === '') {
            grecaptcha.render(recaptchaField[0], {sitekey: recaptchaField.data('recaptcha-sitekey')});
          }
        }
      },
      // Restored: dropped during the bp.js bundle refactor. Called inline as the
      // reCAPTCHA v3 data-callback on the contact form (common/contact.html) and
      // the forgot-password form (mainapp/forgot_password.html); without it those
      // onSubmit callbacks throw and the forms never submit.
      validate_v3_recaptcha_token_no_action: function (token, action, url) {
        var data = {
          'g-recaptcha-response': token,
          'action': action,
          'redirect_url': url,
        };
        $.post('/validate_v3_recaptcha/', data);
      },
      validate_v3_recaptcha_token: function (token, action, url) {
        var data = {
          'g-recaptcha-response': token,
          'action': action,
          'redirect_url': url,
        };

        $.post('/validate_v3_recaptcha/', data).done(function (data) {
          if (data.result !== 'ok') {
            var recaptcha_url = '/recaptcha' + url;
            window.location.href = recaptcha_url;
          }

          if (data.result === 'ok' && data.response.score < 0.4) {
            var recaptcha_url2 = '/recaptcha' + url;
            window.location.href = recaptcha_url2;
          }
        });
      },
      init_rate_limit_form: function () {
        $(document).on('submit', '#bp_rate_limit_form', function (event) {
          event.preventDefault();

          var ratelimit_form = $(this);
          var formData = ratelimit_form.serializeArray();
          var data = {
            'csrfmiddlewaretoken': formData[0].value,
            'g-recaptcha-response': formData[1].value,
          };

          $.post('/validate_recaptcha/', data).done(function (data) {
            if (data.result === 'ok') {
              var url = ratelimit_form.attr('action');
              var new_url = location.protocol + '//' + location.host + url;
              location.href = new_url;
            } else {
              bp.advertisement.render_recaptcha_ratelimit_form();
            }
          });
        });
      },
      open_lightbox: function (event, photo_index) {
        if (event !== undefined && event.type === 'click') {
          var target = event.target ? event.target : event.srcElement;
          if (target.classList.contains('fa-heart') || target.classList.contains('carousel-favourite')) {
            return false;
          }
          $.iLightBox(photoslide_items, {
            skin: 'dark',
            inifinite: true,
            startFrom: photo_index,
            path: 'horizontal',
            controls: {
              arrows: true,
              thumbnail: false,
            },
          });
        }
      },
      open_lightbox_unit: function (event, photo_index, unit_num = 0) {
        if (event !== undefined && event.type === 'click') {
          var target = event.target ? event.target : event.srcElement;
          if (target.classList.contains('fa-heart') || target.classList.contains('carousel-favourite')) {
            return false;
          }
          $.iLightBox(unit_photoslide_items[unit_num], {
            skin: 'dark',
            inifinite: true,
            startFrom: photo_index,
            path: 'horizontal',
            controls: {
              arrows: true,
              thumbnail: false,
            },
          });
        }
      },
      openModalOnHomePage: function (e) {
        e.preventDefault();

        var url = '/data/user-authenticated/';
        $.ajax({
          url: url,
          success: function (result) {
            bpUserIsAuthenticated = result['authenticated'] === 'true';
          },
        });
        var target = event.target ? event.target : event.srcElement;
        var target_modal = $(target).data('target');
        var remote_content = '/data/zoeken/' + target.getAttribute('href') + '/inquiryform/';
        var modal = $(target_modal);
        var modalBody = $(target_modal + ' .contact-form-wrapper');
        $.get(remote_content).done(function (data) {
          modal.on('show.bs.modal', function () {
            modalBody.html(data);
          }).on('hidden.bs.modal', function () {
            if (!bpUserIsAuthenticated) {
              location.reload();
            }
          }).modal();
        });

        return false;
      },
      openModalOnSearch: function (e) {
        e.preventDefault();
        var target = event.target ? event.target : event.srcElement;
        var target_modal = $(target).data('target');
        var remote_content = '/data/zoeken/' + target.getAttribute('href') + '/inquiryform/';
        var modal = $(target_modal);
        var modalBody = $(target_modal + ' .contact-form-wrapper');
        $.get(remote_content).done(function (data) {
          modal.on('show.bs.modal', function () {
            modalBody.html(data);
          }).on('hidden.bs.modal', function () {
            if (!bpUserIsAuthenticated) {
              location.reload();
            }
          }).modal();
        });

        return false;
      },
    };
  })(),
});

export {bp};
